import React from 'react'
import { trans } from '../../../../_providers/Translation'

const Filter = (props) => {

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleClearFilters = () => {
        props.handleSearch('type_id', '')
        props.handleSearch('name', '')
    }

    return (
        <>
            <form className="filter-standard">
                <div className='col'>
                    <input
                        type='search'
                        name='name'
                        onChange={handleSearch}
                        onKeyUp={handleSearch}
                        value={props.filter.name}
                        placeholder={trans('labels.search')}
                    />
                </div>

                <div className='col'>
                    <select
                        onChange={handleSearch}
                        name='type_id'
                        value={props.filter.type_id}
                    >
                        <option value=''>
                            {trans('labels.all')}
                        </option>
                        {props.types.map(i => (
                            <option key={'type-' + i.id} value={i.id}>{i?.translation?.name || i.name}</option>
                        ))}
                    </select>
                </div>

                <div className='col'>
                    <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                        {trans('buttons.clearFilter')}
                    </button>
                </div>
            </form>
        </>
    )
}
export default Filter